import React, { useContext, useState, useEffect } from 'react';

// CONTEXT
import { ThemeContext } from '../context/Themes';
import { SidebarContext } from '../context/Sidebar';
import { TranslatorContext } from '../context/Translator';

// COMPONENTS
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import BranchSelector from '../components/BranchSelector';

// DATA
import languages from '../assets/data/languages.json';
import { clearTokenFromLocalStorage, getUserFromLocalStorage } from '../utils/auth';
import { getAvatarInitials } from '../utils/employeeName';

export default function HeaderLayout({ toggleButtonRef }) {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { sidebar, toggleSidebar } = useContext(SidebarContext);
  const { t, changeLanguage, currentLanguage } = useContext(TranslatorContext);

  const [scroll, setScroll] = useState('fixed');
  const user = getUserFromLocalStorage();
  const userName = user?.full_name || user?.username || '';

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY > 0 ? 'sticky' : 'fixed');
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`mc-header ${scroll}`}>
      <Link
        to="/"
        className="mc-logo-group"
        aria-label="Trang chủ Ồn Coffee"
      >
        <img
          src="/images/micabit-icon-logo.svg"
          alt="Ồn Coffee"
        />
      </Link>
      <div className="mc-header-group">
        <div className="mc-header-left">
          <button
            type="button"
            className="mc-header-icon toggle"
            onClick={toggleSidebar}
            ref={toggleButtonRef}
            aria-label="Thu gọn / mở menu"
          >
            <i className="material-icons">{sidebar ? 'menu_open' : 'menu'}</i>
          </button>

          <div className="mc-header-branch">
            <i className="material-icons">storefront</i>
            <BranchSelector
              className="header-branch-selector"
              showLabel={false}
            />
          </div>
        </div>

        <div className="mc-header-right">
          <button
            type="button"
            className="mc-header-icon theme"
            onClick={toggleTheme}
            aria-label="Đổi giao diện sáng / tối"
          >
            <i className="material-icons">{theme}</i>
          </button>

          <Link
            to="/notification"
            className="mc-dropdown-toggle mc-header-icon"
            aria-label="Thông báo"
          >
            <i className="material-icons">notifications</i>
          </Link>

          <span
            className="mc-header-divider"
            aria-hidden="true"
          />

          <Dropdown className="mc-header-user">
            <Dropdown.Toggle
              className="mc-dropdown-toggle"
              aria-label="Tài khoản"
            >
              <span className="mc-header-avatar">
                {user?.avatar_url ? (
                  <img
                    src={user.avatar_url}
                    alt=""
                  />
                ) : (
                  getAvatarInitials(userName)
                )}
              </span>
              {userName && <span className="mc-header-user-name">{userName}</span>}
            </Dropdown.Toggle>
            <Dropdown.Menu
              align="end"
              className="mc-dropdown-paper"
            >
              <Link
                to="/my-account"
                className="mc-dropdown-menu"
              >
                <i className="material-icons">person</i>
                <span>{t('my_account')}</span>
              </Link>
              <Link
                to="/forgot-password"
                className="mc-dropdown-menu"
              >
                <i className="material-icons">privacy_tip</i>
                <span>{t('reset_password')}</span>
              </Link>
              {/* Bảng cài đặt Trợ năng (công tắc "Hey OSS") của widget lõi dùng chung; ẩn nếu widget chưa nạp. */}
              {typeof window !== 'undefined' && window.SpotFix && window.SpotFix.openSettings && (
                <button
                  type="button"
                  onClick={() => window.SpotFix.openSettings()}
                  className="mc-dropdown-menu"
                >
                  <i className="material-icons">edit</i>
                  <span>Cài đặt Trợ năng</span>
                </button>
              )}
              <div className="mc-header-menu-divider" />
              {languages.map((language) => (
                <button
                  onClick={() => changeLanguage(language.code)}
                  type="button"
                  key={language.code}
                  className="mc-dropdown-menu"
                >
                  <i className="material-icons">
                    {language.code === currentLanguage.code ? 'radio_button_checked' : 'radio_button_unchecked'}
                  </i>
                  <span>{language.name}</span>
                </button>
              ))}
              <div className="mc-header-menu-divider" />
              <Link
                to="/login"
                onClick={clearTokenFromLocalStorage}
                className="mc-dropdown-menu"
              >
                <i className="material-icons">logout</i>
                <span>{t('logout')}</span>
              </Link>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </header>
  );
}
